import { useI18n } from 'vue-i18n';
import { useToast } from 'vue-toast-notification';

import missionsService from '@/modules/missions/services/missionsService';
import { type IMissionList, MissionCommand } from '@/types/mission';

interface UseArchiveOrderOptions {
	onSuccess?: () => void | Promise<void>;
	// biome-ignore lint/suspicious/noExplicitAny: Init Biome
	onError?: (error: any) => void;
	mission?: IMissionList;
}

export const useArchiveOrder = (options: UseArchiveOrderOptions = {}) => {
	const { t } = useI18n();
	const toaster = useToast();

	// biome-ignore lint/correctness/noUnusedVariables: Init Biome
	const { onSuccess, onError, mission } = options;

	const archiveOrder = async (
		missionId: string,
		// biome-ignore lint/correctness/noUnusedFunctionParameters: Init Biome
		currentMission?: IMissionList
	) => {
		try {
			toaster?.open({
				message: t('global.inProcess'),
				type: 'info',
				duration: 2500,
			});

			await missionsService.sendCommandMission({
				missionId: missionId,
				command: MissionCommand.archive,
			});

			toaster?.open({
				message: 'Mission archivée avec succès !',
				type: 'success',
				duration: 5000,
			});

			if (onSuccess) {
				await onSuccess();
			}
		} catch (err) {
			console.error('error:', err);

			if (onError) {
				onError(err);
			}

			toaster?.open({
				message: "Une erreur est survenue lors de l'archivage de la mission",
				type: 'error',
				duration: 5000,
			});
		}
	};

	return {
		archiveOrder,
	};
};
